export default __webpack_public_path__ + "static/media/customer1.efa557c6.svg";